export const ColorMap = {
  "Systolic": {
    high: {
      min: 120,
      max: 140
    },
    critical: {
      min: 0,
      max: 140
    }
  },
  "Diastolic": {
    high: {
      min: 80,
      max: 90
    },
    critical: {
      min: 0,
      max: 90
    }
  },
  "Heart Rate": {
    high: {
      min: 100,
      max: 120
    },
    critical: {
      min: 60,
      max: 120
    }
  },
  "Body Temperature": {
    "high": {
      "min": 37.2,
      "max": 37.9
    },
    "critical": {
      "min": 35,
      "max": 37.9
    }
  },  
  "Respiratory Rate": {
    high: {
      min: 21,
      max: 24
    },
    critical: {
      min: 12,
      max: 24
    }
  },
  "Blood Glucose": {
    high: {
      min: 100,
      max: 126
    },
    critical: {
      min: 70,
      max: 126
    }
  },
  "Blood Glucose Level": {
    high: {
      min: 100,
      max: 126
    },
    critical: {
      min: 70,
      max: 126
    },
  },
  "Oxygen Saturation by Pulse Oximetry": {
    high: {
      min: 91,
      max: 94
    },
    critical: {
      min: 91,
      max: 100
    }
  },
  "SPO2 Levels": {
    high: {
      min: 91,
      max: 94
    },
    critical: {
      min: 91,
      max: 100
    }

  },
  'Body Mass Index': {
    high: {
      min: 25,
      max: 29
    },
    critical: {
      min: 18,
      max: 30
    }
  },
  'kg/m2': {
    high: {
      min: 25,
      max: 29
    },
    critical: {
      min: 18,
      max: 30
    }
  }
}

export const getColorVal = (key: keyof typeof ColorMap): Object => {
  return ColorMap[key];
}